import {PageModel, Project, ProjectAPI, Tag, TeamAPI, GetProjectsByFilterProps} from '@brg/api';

import { useAPIMethodArray } from '../useAPIMethodArray';
import { useAPIMethod } from '../useAPIMethod';

export const useProjectsByFilter = (request: GetProjectsByFilterProps, lang = 'en', t?: number) =>
  useAPIMethodArray<Project, any>(ProjectAPI.GetProjectsByFilter, request, lang, t);

export const useProjectsList = (request: GetProjectsByFilterProps | null, lang = 'en', t?: number, disabled?: boolean, isTeamProjects?: boolean, withOtherProjects?: boolean, setIsLoadingExt?: any ) =>
  useAPIMethod<PageModel<Project>, any>(withOtherProjects ? ProjectAPI.GetListForAuthorIdsAndProjectIds : isTeamProjects ? TeamAPI.GetPending : ProjectAPI.GetList, request, lang, t, disabled, setIsLoadingExt);

export const useGetProjectTags = (request: GetProjectsByFilterProps | null, lang = 'en', t?: number, disabled?: boolean) =>
  useAPIMethod<Tag[], any>(ProjectAPI.GetProjectTags, request, lang, t, disabled);

export const useTagsProjects = (request: any, lang = 'en', t?: number) =>
  useAPIMethodArray<Tag, any>(ProjectAPI.GetTagsProjects, request, lang, t);
import {PageModel, Project, ProjectAPI, Tag, TeamAPI, GetProjectsByFilterProps} from '@brg/api';

import { useAPIMethodArray } from '../useAPIMethodArray';
import { useAPIMethod } from '../useAPIMethod';

export const useProjectsByFilter = (request: GetProjectsByFilterProps, lang = 'en', t?: number) =>
  useAPIMethodArray<Project, any>(ProjectAPI.GetProjectsByFilter, request, lang, t);

export const useProjectsList = (request: GetProjectsByFilterProps | null, lang = 'en', t?: number, disabled?: boolean, isTeamProjects?: boolean, withOtherProjects?: boolean, setIsLoadingExt?: any ) =>
  useAPIMethod<PageModel<Project>, any>(withOtherProjects ? ProjectAPI.GetListForAuthorIdsAndProjectIds : isTeamProjects ? TeamAPI.GetPending : ProjectAPI.GetList, request, lang, t, disabled, setIsLoadingExt);

export const useGetProjectTags = (request: GetProjectsByFilterProps | null, lang = 'en', t?: number, disabled?: boolean) =>
  useAPIMethod<Tag[], any>(ProjectAPI.GetProjectTags, request, lang, t, disabled);

export const useTagsProjects = (request: any, lang = 'en', t?: number) =>
  useAPIMethodArray<Tag, any>(ProjectAPI.GetTagsProjects, request, lang, t);
